(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/search.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/search.js');

'use strict';

const logger = svs.lyckoplatsen.logger;
const {
  useState,
  useRef,
  useCallback,
  useEffect
} = React;
const {
  Inputv2,
  ControlGroup,
  Form
} = svs.ui.reactForm;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const {
  ListGroup,
  ListItem
} = svs.ui.ReactListGroup;
const {
  useSetAtom,
  useAtom
} = jotai;
const {
  mapLocationAtom,
  pinLocationAtom,
  pinLocationTypeAtom,
  shouldShowOverlayAtom,
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  fetchGeolocationSearch,
  fetchGeolocationCoordinates
} = svs.lyckoplatsen.components.page_play.utils;
const memoFetchGeoLocationSearch = _.memoize(fetchGeolocationSearch);
const memoFetchGeoLocationCoordinates = _.memoize(fetchGeolocationCoordinates);
const {
  scrambleCoordinates
} = svs.tur.lyckoplatsen.map;
const {
  showLocationCoordsError
} = svs.lyckoplatsen.components.page_play.utils;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const Search = () => {
  const setMapLocation = useSetAtom(mapLocationAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setShouldShowPin = useSetAtom(shouldShowPinAtom);
  const [shouldShowOverlay, setShouldShowOverlay] = useAtom(shouldShowOverlayAtom);
  const [input, setInput] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasSelected, setHasSelected] = useState(false);
  const [autoComplete, setAutoComplete] = useState([]);
  const [noSuggestions, setNoSuggestions] = useState(false);
  const [searchError, setSearchError] = useState(false);
  const hasOpenDialogRef = useRef(false);
  const inputRef = useRef(null);
  const listContainerRef = useRef(null);
  const closeAutoComplete = useCallback(() => {
    setShouldShowOverlay(false);
    setHasSelected(false);
    setAutoComplete([]);
    setInput('');
    setCurrentIndex(0);
  }, [setShouldShowOverlay]);
  const fetchSuggestions = async text => {
    let values;
    try {
      values = await memoFetchGeoLocationSearch(text);
    } catch (error) {
      logger.error('Error fetching search results', error);
      if (!hasOpenDialogRef.current) {
        hasOpenDialogRef.current = true;
        showLocationCoordsError(() => {
          hasOpenDialogRef.current = false;
        });
      }
      setSearchError(true);
      return;
    }
    if (!values || !values.places.length && !values.addresses.length) {
      setAutoComplete([]);
      setNoSuggestions(true);
    } else {
      const allValues = [...values.places, ...values.addresses];
      const reducedValues = allValues.slice(0, 15);
      setAutoComplete(reducedValues);
      setNoSuggestions(false);
      setSearchError(false);
    }
  };
  const debouncedFetchSuggestions = useRef(_.debounce(text => {
    if (!text.length) {
      setAutoComplete([]);
      setNoSuggestions(false);
      return;
    }
    fetchSuggestions(text);
  }, 500)).current;
  const scrollToItem = index => {
    if (listContainerRef.current) {
      const listItems = listContainerRef.current.querySelectorAll('.list-group-item');
      if (listItems[index]) {
        listItems[index].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  };
  const handleChange = e => {
    const text = e.target.value;
    setCurrentIndex(0);
    scrollToItem(0);
    setInput(text);
    debouncedFetchSuggestions(text);
  };
  const handleOnFocus = () => {
    setHasSelected(true);
    setShouldShowOverlay(true);
  };
  const handleOnBlur = () => {
    setTimeout(() => {
      closeAutoComplete();
    }, 600);
  };
  const handleSelect = async item => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök',
      opt_label: 'search'
    });
    if (!item) {
      return;
    }
    closeAutoComplete();
    let data;
    try {
      data = await memoFetchGeoLocationCoordinates(item.id);
    } catch (error) {
      logger.error('Error fetching coordinates', error);
    }
    if (!data) {
      if (!hasOpenDialogRef.current) {
        hasOpenDialogRef.current = true;
        showLocationCoordsError(() => {
          hasOpenDialogRef.current = false;
        });
      }
      return;
    }
    if (data.type === CONSTANTS.GEO_SEARCH_TYPES.ADDRESS) {
      setShouldShowPin(false);
      setPinLocationType(CONSTANTS.LOCATION_TYPES.OTHER);
      setPinLocation({
        lat: data.latitude,
        lng: data.longitude
      });
    } else {
      setMapLocation({
        lat: scrambleCoordinates(data.latitude),
        lng: scrambleCoordinates(data.longitude)
      });
    }
  };
  const handleInputKeyDown = e => {
    switch (e.key) {
      case 'Tab':
        closeAutoComplete();
        break;
      case 'Escape':
        closeAutoComplete();
        handleOnFocus();
        break;
      case 'Enter':
        if (autoComplete[0]) {
          const mapEl = document.getElementById('mapPlay');
          mapEl.focus();
          const inputEl = document.querySelector('.standard-input');
          if (inputEl) {
            inputEl.blur();
          }
          handleSelect(autoComplete[currentIndex]);
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        setCurrentIndex(prevIndex => {
          const newIndex = (prevIndex + 1) % autoComplete.length;
          scrollToItem(newIndex);
          return newIndex;
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        setCurrentIndex(prevIndex => {
          const newIndex = (prevIndex - 1 + autoComplete.length) % autoComplete.length;
          scrollToItem(newIndex);
          return newIndex;
        });
        break;
      default:
        break;
    }
  };
  const handleListItemKeyDown = (e, index, item) => {
    switch (e.key) {
      case 'Tab':
        if (index === autoComplete.length - 1 && !e.shiftKey) {
          closeAutoComplete();
        }
        break;
      case 'Enter':
        handleSelect(item);
        break;
      default:
        break;
    }
  };
  const handleIconClick = e => {
    e.preventDefault();
    if (!hasSelected) {
      return;
    }
    handleSelect(autoComplete[currentIndex]);
  };
  const shouldShowAutoComplete = Boolean(input.length && hasSelected);
  useEffect(() => {
    if (!shouldShowOverlay) {
      closeAutoComplete();
    }
  }, [closeAutoComplete, shouldShowOverlay]);
  return React.createElement("div", {
    className: "lp-search",
    ref: inputRef
  }, React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    v2: true,
    className: "lp-search-input-control relative"
  }, React.createElement(Inputv2, {
    id: "locationInput",
    autoComplete: "off",
    label: "S\xF6k din lyckoplats",
    onBlur: handleOnBlur,
    onFocus: handleOnFocus,
    onChange: handleChange,
    onKeyDown: handleInputKeyDown,
    required: true,
    value: input,
    role: "combobox",
    "aria-label": "S\xF6k platser",
    "aria-autocomplete": "list",
    "aria-owns": "autocomplete-list",
    "aria-expanded": Boolean(input),
    "aria-controls": "autocomplete-list",
    "aria-haspopup": "listbox"
  }), React.createElement(IconButton, {
    className: "search-button",
    onClick: handleIconClick,
    title: "S\xF6k knapp",
    "aria-label": "Search",
    tabIndex: "-1"
  }, React.createElement(Icon, {
    icon: "search"
  })), shouldShowAutoComplete && React.createElement("div", {
    className: "lp-search-autocomplete-field",
    ref: listContainerRef
  }, React.createElement(ListGroup, {
    role: "listbox",
    "aria-label": "S\xF6k f\xF6rslag"
  }, noSuggestions && React.createElement(ListItem, {
    role: "alert",
    "aria-disabled": "true",
    className: "lp-no-suggestions"
  }, "Vi hittade ingen plats med det namnet. ", React.createElement("span", null, "Kolla stavningen eller testa en annan plats.")), searchError && React.createElement(ListItem, {
    role: "alert",
    className: "lp-error-item",
    "aria-disabled": "true"
  }, "Just nu fungerar inte s\xF6kfunktionen."), autoComplete.map((item, index) => {
    var _item$textDisplay;
    return React.createElement(ListItem, {
      key: _.uniqueId(),
      onKeyDown: event => handleListItemKeyDown(event, index, item),
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        handleSelect(item);
      },
      role: "option",
      "aria-selected": currentIndex === index,
      className: currentIndex === index ? 'selected' : ''
    }, React.createElement("span", {
      className: "auto-complete-text"
    }, (_item$textDisplay = item.textDisplay) !== null && _item$textDisplay !== void 0 ? _item$textDisplay : item.text), !item.placeType && React.createElement(PinIcon, {
      className: "pin-icon",
      color: "black"
    }));
  }))))));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Search
});

 })(window);